module.exports = __webpack_public_path__ + "img/undraw-pickup.a0d59132.svg";